import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreTags',
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    // eslint-disable-next-line vue/require-prop-types
    height: {
      default: 'auto',
      required: false
    },
    tagListType: {
      type: String,
      default: 'digitalTwin',
      required: false
    },
    tagLabel: {
      type: String,
      default: '',
      required: false
    },
    deviceTemplate: {
      type: Object,
      default: function _default() {
        return null;
      },
      required: false
    }
  },
  data: function data() {
    return {
      search: '',
      tagItems: ['Building', 'Room', 'Door', 'School', 'accessMgmt', 'District']
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    templateTags: function templateTags() {
      return this.deviceTemplate ? this.deviceTemplate.deviceMeta.tags : [];
    }
  }),
  mounted: function mounted() {
    this.fetchTagList();
  },
  methods: {
    process: function process() {
      this.search = '';
      this.$emit('tagsChosen', this.twinObject);
    },
    remove: function remove(item) {
      if (this.templateTags.includes(item)) {
        return;
      }

      this.twinObject.tags.splice(this.twinObject.tags.indexOf(item), 1);
      this.twinObject.tags = _toConsumableArray(this.twinObject.tags);
      this.process();
    },
    fetchTagList: function fetchTagList() {
      var _this = this;

      if (this.tagListType === 'digitalTwin') {
        ApiService.digitalTwinFetchTagsAndZones().then(function (res) {
          _this.tagItems = res.tagList || [];
        }).catch(function (error) {
          console.error(error);
        });
      } else {
        ApiService.virtualDeviceFetchTagsAndZones().then(function (res) {
          _this.tagItems = res.tagList || [];

          if (_this.deviceTemplate) {
            _this.tagItems = _this.tagItems.map(function (tag) {
              return {
                text: tag,
                value: tag,
                disabled: _this.templateTags.includes(tag)
              };
            });
          }
        }).catch(function (error) {
          console.error(error);
        });
      }
    },
    restrictCharacters: function restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    }
  }
};